import React, { FC } from 'react';
import ItemsListWrapper from '@v2/pages/machines/common/wrappers/ItemsListWrapper/ItemsListWrapper';
import { ItemsListWrapperWithoutRenderProps, ItemWrapperProps } from '@v2/pages/machines/common/types/props';
import { TimelineItem } from '@v2/pages/machines/modules/timeline/components/TimelineItem/TimelineItem';

interface TimelineItemsListProps extends ItemsListWrapperWithoutRenderProps {}

const TimelineItemsList: FC<TimelineItemsListProps> = (props) => {
  return (
    <ItemsListWrapper
      {...props}
      getItemElement={({ C, item, loading, selected, timeOffset }: ItemWrapperProps) => (
        <TimelineItem {...{ C, item, loading, selected, timeOffset }} />
      )}
    />
  );
};

export { TimelineItemsList };
